import { getEnvErrorMessage } from "@roman/shared/utils/error";
import * as z from "zod";

const EnvSchema = z.object({
  DEV: z
    .string()
    .refine((s) => s === "true" || s === "false")
    .transform((s) => s === "true"),
  API_URL: z.string(),
  PORT: z.string().transform((s) => Number.parseInt(s)),
  GOOGLE_CLIENT_ID: z.string(),
  APPLE_CLIENT_ID: z.string(),
  APPLE_REDIRECT_URI: z.string(),
});

export type WebEnv = z.infer<typeof EnvSchema>;

export const createWebEnv = (): WebEnv => {
  const envVars = Object.entries(import.meta.env).reduce<Record<string, string>>((acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith("FARM_")) {
      acc[key.replace("FARM_", "")] = value;
    }
    return acc;
  }, {});

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(getEnvErrorMessage(parsedEnv.error));
  }

  return parsedEnv.data;
};

export const webEnv = createWebEnv();
